import { Common } from '@thecvlb/design-system/lib/src';

import { BaseModalProps } from 'modals/modal.types';

const WhereToCheckBloodPressure: React.FC<BaseModalProps> = ({ isOpen, onClose }) => {
  return (
    <Common.Modal close={onClose} isOpen={isOpen} padding={false} size="sm">
      <div className="p-4">
        <div className="mb-6 flex flex-col items-center md:mb-8">
          <h3 className="mb-4 text-xl font-bold md:mb-2">Where to check your blood pressure</h3>
          <div className="flex w-full flex-col gap-4 rounded-2xl bg-gray-100 p-4">
            <div className="flex flex-col gap-1">
              <span className="font-bold text-gray-700">Visit a pharmacy</span>
              <span className="text-mSm text-gray md:text-sm">
                Many pharmacies offer free blood pressure checks. Simply visit your local pharmacy
                and ask for assistance.
              </span>
            </div>
            <div className="flex flex-col gap-1">
              <span className="font-bold text-gray-700">Use a community health station</span>
              <span className="text-mSm text-gray md:text-sm">
                Some community centers and health clinics provide free or low-cost blood pressure
                monitoring.
              </span>
            </div>
            <div className="flex flex-col gap-1">
              <span className="font-bold text-gray-700">Head to your gym</span>
              <span className="text-mSm text-gray md:text-sm">
                Some gyms have blood pressure machines available for members to use.
              </span>
            </div>
          </div>
        </div>
        <Common.Button color="white-alt" fullWidthOnMobile onClick={onClose}>
          Close
        </Common.Button>
      </div>
    </Common.Modal>
  );
};

export default WhereToCheckBloodPressure;
